import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Button } from "@heroui/react";
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks";
import { apiRoute, ENUM_PAGEACTION_TYPE, linksUrl } from "../../constants/enum";
import { ErrorCard, LoadingCard, MainContainer, NextUITable } from "../../components";
import { COLUMN_ALIGN_TYPE, ROW_ACTION_BTN_TYPE } from "../../components/NextUITable";
import { toast } from "react-toastify";
import ConfirmBox from "../../components/ConfirmBox";
import { setDetailParams, setNewEntryMode } from "../../state/shapeSlice";


const ShapeMaster = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);

    const [itemToDelete, setItemToDelete] = useState("")
    const [itemToEdit, setItemToEdit] = useState("")
    const [pageActionType, setPageActionType] = useState("")
    // Fetch shape data
    const {
        data: shapeData = [],
        isPending,
        isError,
        mutate: filterData
    } = usePost({
        url: apiRoute.shape.getShape,
        queryKey: "fetchShapeMaster",
    });

    const funLoadData = () => {
        filterData({
            data: {}
        })
    }
    useEffect(() => {
        funLoadData();
    }, [])
    const sortedShapeData = [...shapeData].sort((a, b) => a.S_Ord - b.S_Ord);


    const onSuccessDelete = (data) => {
         if (data && data.length > 0) {
            if (data[0].ref == 1) {
                toast.error("Shape can't be delete as it locked", {
                    position: "top-center",
                    "className": "toast-error",
                })
            }
            else {
                setItemToDelete("")
                funLoadData();
               

            }


        }
    };

    // Delete shape mutation
    const { mutate: deleteShape } = usePost({
        url: apiRoute.shape.deleteShape,
        queryKey: "deleteShapeMaster",
        onSuccessTasks: onSuccessDelete,
        //successMessage: "Shape deleted successfully!",
    });

    // Open confirmation box
    const handleDeleteClick = (S_Code) => {
        if (!S_Code) {
            toast.error("Error: Shape Code is missing.");
            return;
        }
        else
            setItemToDelete(S_Code)
    };

    const handleConfirmBox = (data) => {
        if (data) {
            if (itemToDelete && itemToDelete != null) {
                deleteShape({ data: { S_Code: itemToDelete } });
            }
            else if (itemToEdit != "" & itemToEdit != null && Object.keys(itemToEdit).length > 0) {
                dispatch(setDetailParams(itemToEdit));
                dispatch(setNewEntryMode(false))
                navigate(linksUrl.diamondParamater.shape.createShapeMaster);
            }
        }
        else {
            setItemToDelete("")
        }
    };

    const handleAddNew = () => {
        dispatch(setNewEntryMode(true));
        dispatch(setDetailParams([]));
        navigate(linksUrl.diamondParamater.shape.createShapeMaster);
    };

    const exportColumns = [
        { name: "Shape Code", uid: "S_Code" },
        { name: "Shape Name", uid: "S_Name" },
        { name: "Shape Group", uid: "S_Group" },
        { name: "Shape Order", uid: "S_Ord" },
    ]
    const downloadDataFooter = {
        S_Code: "", S_Name: "", S_Group: "", S_Ord: ""
    }


    const columns = [
        { name: "Actions", uid: "actions", align: COLUMN_ALIGN_TYPE.center },
        { name: "Shape Code", uid: "S_Code", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "Shape Name", uid: "S_Name", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "Shape Group", uid: "S_Group", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "Shape Order", uid: "S_Ord", sortable: true, align: COLUMN_ALIGN_TYPE.center },
    ];

    const rowActionBtn = [
        {
            icon: <FontAwesomeIcon icon={faEdit} style={{ color: "#379906" }} />,
            onClick: (row) => {
                setItemToDelete("")
                setPageActionType(ENUM_PAGEACTION_TYPE.Edit)
                let obj = {
                    S_Code: row.S_Code
                };
                setItemToEdit(obj)

            },
            type: ROW_ACTION_BTN_TYPE.link,
        },
        {
            icon: <FontAwesomeIcon icon={faTrash} style={{ color: "#c40c18" }} />,
            onClick: (row) => {
                setItemToEdit("")
                setPageActionType(ENUM_PAGEACTION_TYPE.Delete)
                handleDeleteClick(row.S_Code);
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },
    ];

    if (isPending) return <LoadingCard />;
    if (isError) return <ErrorCard />;

    return (
        <div>
            <MainContainer pageName="Shape" breadcrumbs={["Diamond Parameter", "Shape Master"]}>
                <div className="text-right mb-4">
                    <Button size="sm" color="primary" startContent={<FontAwesomeIcon icon={faPlus} />} onPress={handleAddNew}>
                        Add New
                    </Button>
                </div>
                <NextUITable
                    INITIAL_VISIBLE_COLUMNS={["actions", "S_Code", "S_Name", "S_Group", "S_Ord"]}
                    data={sortedShapeData}
                    columns={columns}
                    rowActionBtn={rowActionBtn}
                    showAdvanceFilter={false}
                    exportColumns={exportColumns}
                    downloadDataFooter={downloadDataFooter}
                    downloadFileName="Shape-master-List"
                    id="S_Code"

                />
            </MainContainer>

            {(itemToDelete || itemToEdit) && (
                <ConfirmBox
                    handleConfirmBox={handleConfirmBox}
                    actionType={pageActionType}
                />
            )}
        </div>
    );
};

export default ShapeMaster;
